import axios from "axios";
import { resolveBackendBase } from "@/lib/api";

// Separate axios instance + token from the tenant-facing lib/api.js:
// an admin session and a tenant session can coexist in the same browser
// (e.g. two tabs), so they must never share a localStorage key or an
// Authorization header. Same LAN-aware host resolution as the tenant client,
// so the admin page works when opened via this machine's IP.
const BASE = `${resolveBackendBase()}/api/admin`;
const TOKEN_KEY = "agri_admin_token";

const adminApi = axios.create({ baseURL: BASE, timeout: 15000 });

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);
export const setAdminToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

adminApi.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      clearAdminToken();
      window.dispatchEvent(new Event("agri-admin-unauth"));
    }
    return Promise.reject(err);
  }
);

export default adminApi;
